/* Audio actions */
export const NARRATE_AVATAR = 'NARRATE_AVATAR';
export const NARRATE_START = 'NARRATE_START';
export const NARRATE_RESET = 'NARRATE_RESET';

export const STOP_AUDIO = 'STOP_AUDIO';
export const PLAY_AUDIO = 'PLAY_AUDIO';
export const PAUSE_AUDIO = 'PAUSE_AUDIO';
export const RESUME_AUDIO = 'RESUME_AUDIO';
export const SET_CAPTION = 'SET_CAPTION';

export const stopAudio = () => ({
    type: 'STOP_AUDIO',
});

export const pauseAudio = () => ({
    type: PAUSE_AUDIO,
});

export const resumeAudio = () => ({
    type: RESUME_AUDIO,
});

export const playAudio = (audioTracks, delay = 0, onPlayCallback = null, onEndCallback = null) => ({
    type: 'PLAY_AUDIO',
    audioTracks,
    delay,
    onPlayCallback,
    onEndCallback,
});

export const narrateStart = () => ({
    type: NARRATE_START,
});

export const narrateReset = () => ({
    type: NARRATE_RESET,
});

export const setCaption = caption => ({
    type: SET_CAPTION,
    payload: caption,
});

